const isInputElement = (e: Event): boolean => {
  const target = e.target;

  if (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    (target instanceof HTMLElement && target?.isContentEditable)
  ) {
    return true;
  }
  return false;
};

export default isInputElement;
